import React from "react";

export default function analyticsReporting({ color = "white" }) {
  const str1 = "a5.956 5.956 0 0 1";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
      <path
        fill={color}
        fillRule="evenodd"
        d={`M8.5 14.444c-3.285 0-5.95-2.671-5.95-5.965${str1} 5.1-5.897V0C3.35.427 0 4.06 0 8.479 0 13.187 3.8 17 8.496 17c2.813 0 5.3-1.376 6.847-3.485l-2.207-1.303A5.923 5.923 0 0 1 8.5 14.444M9.35 0v2.582${str1} 4.692 8.057l2.21 1.308A8.503 8.503 0 0 0 17 8.48 8.516 8.516 0 0 0 9.35 0`}
      />
    </svg>
  );
}
